import { createAsyncThunk } from "@reduxjs/toolkit";
import AddPurchaseOrderService from "@/services/api/cresivoxServer/AddPurchaseOrderdata";
import { iPurchaseOrderDetailDTO } from "./Types";
import { apiServer } from "@/services/api/cresivoxServer/axiosConfig";

// ✅ Add Purchase Order
export const addPruchaseOrderProduct = createAsyncThunk(
  "purchaseOrder/create",
  async (data: iPurchaseOrderDetailDTO, { rejectWithValue }) => {
    try {
      const service = AddPurchaseOrderService(apiServer);
      const response = await service.addPruchaseOrderProduct(data);

      // @ts-expect-error custom response wrapper
      if (response?.statusCode === 200) {
        return response?.data;
      } else {
        // @ts-ignore
        return rejectWithValue(response?.errorMessage || "Something went wrong");
      }
    } catch (error: any) {
      return rejectWithValue(error.message || "Network Error");
    }
  }
);

// ✅ Get Purchase Orders
export const getPurchaseOrderDetail = createAsyncThunk(
  "purchaseOrder/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const service = AddPurchaseOrderService(apiServer);
      const response = await service.getPruchaseOrderProduct();

     
      
      if (response) {
        return response?.data.data;
      } else {
        // @ts-ignore
        return rejectWithValue(response?.errorMessage || "Something went wrong");
        
      }
    } catch (error: any) {
      return rejectWithValue(error.message || "Network Error");
    }
  }
);
